/** @format */
import {
    Skeleton,
    SkeletonVariant,
} from '@mpb-com/feather/components/atoms/skeleton';
import React from 'react';
import styled from 'styled-components';

import { Link, LinkVariant } from '@toucan/client/shared/components/link';

import { styles } from './trustpilot-x-cover.styles';

const xcoverTrustPilotLink = 'https://www.trustpilot.com/review/xcover.com';

export const DEFAULT_TEST_ID = 'x-cover__trustpilot-link';

type TrustPilotXCoverProps = {
    className?: string;
    'data-testid'?: string;
};

type TrustPilotXCoverSkeletonProps = {
    'data-testid'?: string;
};

const StyledTrustPilotXCover = styled('div')`
    ${styles}
`;

export const TrustPilotXCoverSkeleton = ({
    'data-testid': dataTestid = `${DEFAULT_TEST_ID}__skeleton`,
}: TrustPilotXCoverSkeletonProps) => {
    return (
        <StyledTrustPilotXCover>
            <Skeleton variant={SkeletonVariant.TEXT} data-testid={dataTestid} />
        </StyledTrustPilotXCover>
    );
};

export const TrustPilotXCover = ({
    'data-testid': dataTestid = DEFAULT_TEST_ID,
    className = 'x-cover-trustpilot-link',
}: TrustPilotXCoverProps) => {
    return (
        <StyledTrustPilotXCover>
            <Link
                className={className}
                variant={LinkVariant.CUSTOM}
                href={xcoverTrustPilotLink}
                target="_blank"
                data-testid={dataTestid}
            >
                <img src="https://static.cms.xcover.com/media/images/Trustpilot_10x.original.png" />
            </Link>
        </StyledTrustPilotXCover>
    );
};
